<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>访客</h4>
        <!-- <span class="f-s-14 c-m-l-15">管理个人客户和公司客户</span> -->
      </div>
      <div class="c-flex">
        <el-input
          placeholder="请输入姓名或昵称或手机号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- <el-button type="primary" @click="doNew" class="c-m-l-10">新建客户</el-button> -->
        <!-- <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            //osg.export('ZUser', {
            // 'regex:name|string#or': searchValue,
            // 'regex:phone|string#or': searchValue,
            // 'regex:email|string#or': searchValue
            //})
            osg.doExport({
              'fpi-regex:name|string#or': searchValue,
              'fpi-regex:phone|string#or': searchValue,
              'fpi-regex:email|string#or': searchValue,
              beanName: 'ZUser',
              title: '客户列表'
            })
          "
        >
          数据导出
        </el-button> -->
      </div>
    </div>
    <div class="content-box">
      <!-- <div class="content-filter">
        <c-filter></c-filter>
      </div> -->
      <div class="content-table">
        <el-table
          ref="table"
          :data="fpi.data"
          empty-text="该组织暂无人员"
          height="calc(100% - 50px)"
          highlight-current-row
        >
          <el-table-column prop="_id" label="编号" min-width="150px"></el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="负责人" placement="top-end">
                <i class="fa fa-user-tie" v-show="scope.row.isHead"></i>
              </el-tooltip>
              {{ scope.row.name }}
            </template>
          </el-table-column>

          <el-table-column prop="nickname" label="昵称"></el-table-column>
          <el-table-column prop="headimgurl" label="头像">
            <template slot-scope="scope">
              <img
                v-if="scope.row.headimgurl"
                :src="scope.row.headimgurl"
                style="width:50px;height:50px;border-radius: 50%;"
                alt=""
              />
              <img
                v-else
                src="../../../src/assets/user.png"
                style="width:50px;height:50px;border-radius: 50%;"
                alt=""
              />
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="province" label="省"></el-table-column>
          <el-table-column prop="city" label="市"></el-table-column>
          <el-table-column prop="country" label="国家"></el-table-column>
          <el-table-column prop="from" label="渠道"></el-table-column>
          <el-table-column prop="shareUserName" label="推荐人名称"></el-table-column>
          <el-table-column prop="sharedUserCount" label="推荐人数量"></el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column label="性别" width="100px">
            <template slot-scope="scope">
              <span>
                {{ scope.row.sex == '1' ? '男' : scope.row.sex == '2' ? '女' : '' }}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="角色">
            <template slot-scope="scope">
              <span>{{ renderLabel('roles', scope.row.roleIds) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="服务资源" width="150px">
            <template slot-scope="scope">
              <router-link
                target="_blank"
                :to="{
                  path: `/ServiceResource/${scope.row.serviceResourceId}`
                }"
              >
                <el-button type="text">{{ formatSR(scope.row.serviceResourceId) }}</el-button>
              </router-link>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="email" label="邮箱" width="150px"></el-table-column> -->
          <!-- <el-table-column label="操作" :width="activeOrg._id ? 340 : 260" fixed="right">
              <template slot-scope="scope">
                <el-button
                  v-show="activeOrg._id"
                  @click.native.prevent="userHead(scope.row)"
                  size="mini"
                >
                  {{ scope.row.isHead ? '取消负责人' : '设为负责人' }}
                </el-button>
                <el-button @click.native.prevent="userEdit(scope.row)" size="mini">编辑</el-button>
                <el-button size="mini" @click.native.prevent="resetPassword(scope.row)">
                  重置密码
                </el-button>
              </template>
            </el-table-column> -->
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
// import areaList from '../../resources/js/areaList.js';
export default {
  name: 'ZUser',
  props: {
    serviceState: {
      type: String
    }
  },
  data() {
    return {
      name: 'ZUser',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        cascadeCode_channel: { codeId: 'channel' },
        codecfg_leadStatus: { codeId: 'LEADSTATUS' },
        codecfg_lifecycleStage: { codeId: 'LIFECYCLESTAGE' }
      },
      //地址级联
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      formDataSA: { exts: {} }, //工单表单
      openDetailSA: false, //工单弹窗
      extFieldsSA: [], //工单扩展
      userList: [] // user列表,用于反显id
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  async mounted() {
    this.doInit();
    // await this.getExtFieldsSA();
    this.osg.getFields('ZUser', () => {
      this.osg.codeoption(() => {
        this.osg.getFpi();
        this.getData();
      });
    });
  },
  methods: {
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatProvince(row, column, cellValue) {
      return this.osg.areaObj.province_list[cellValue];
    },
    formatCity(row, column, cellValue) {
      return this.osg.areaObj.city_list[cellValue];
    },
    formatDistrict(row, column, cellValue) {
      return this.osg.areaObj.county_list[cellValue];
    },
    formatState(row, column, cellValue) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatLeadStatus(row, column, cellValue) {
      return this.osg.codelabel('leadStatus', cellValue);
    },
    formatLifecycleStage(row, column, cellValue) {
      return this.osg.codelabel('lifecycleStage', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:email|string#or': this.searchValue,
        'regex:nickname|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      //   $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('user/queryZuser.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
        // this.getUserList(
        //   res.data.filter(item => item.shareUserId).map(item => item.shareUserId),
        //   () => {
        //   }
        // );
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      var row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      this.$util.saveExtField(this.extFields, this.formData);
      if (this.osg.validate()) {
        // 赋值省市区
        this.formData.area = this.formData.area || [];
        this.formData.province = this.formData.area[0] || '';
        this.formData.city = this.formData.area[1] || '';
        this.formData.district = this.formData.area[2] || '';

        this.osg.ajax('basic/ZUser/upsert.do', this.formData, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    //转工单操作按钮
    doConver(row) {
      var row = this.$util.deepCopy(row);
      this.openDetailSA = true;
      this.formDataSA = {
        contactIds: [row._id],
        name: row.name,
        address: row.address,
        area: row.area,
        belongTo: row.belongTo,
        province: row.province,
        city: row.city,
        district: row.district,
        phone: row.phone,
        exts: {}
      };
      console.log(this.formDataSA);
    },
    doSaveSA() {
      if (this.osg.validate('formDataSA')) {
        var params = this.formDataSA;
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
            }
          }
        }
        // delete params.area;
        this.osg.ajax(
          'basic/serviceAppointment/upsert.do',
          { data: JSON.stringify(params) },
          () => {
            this.doInit();
            this.getData();
            // this.osg.confirm('保存成功！需要跳转到工单吗？', () => {
            //   this.$router.push({ path: '/ServiceAppointments' });
            // });
            this.osg.toast('操作成功！');
          }
        );
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/ZUser/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/ZUser/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    //获取user列表
    getUserList(userIds, callback) {
      if (!(Array.isArray(userIds) && userIds.length)) return;
      this.osg.ajax(
        'user/query.do',
        {
          'in:_id|Array#and': userIds.join(',')
        },
        res => {
          this.userList = res.data;
          if (callback) callback();
        }
      );
    }
    // //反显user;
    // formatterUser(row, column, cellValue) {
    //   for (let item of this.userList) {
    //     console.log(item._id, cellValue);
    //     if (item._id == cellValue) {
    //       console.log(item);
    //       return item.name;
    //     } else {
    //       return cellValue;
    //     }
    //   }
    // }
  }
};
</script>
